import React, { useEffect } from 'react';
import ParticlesBg from 'particles-bg';
import AOS from 'aos';
import 'aos/dist/aos.css';

export const Odooheader = (props) => {
  useEffect(() => {
    AOS.init({
      duration: 1000, 
  
    });
  }, []);

  return (
    <header >
      <div style={{ backgroundColor: '#000000' }} className='intro' data-aos='fade-up'>
        <ParticlesBg
          type='color'
       
        
          bg={{ zIndex: 0, position: 'absolute', top: 0 }}
        />
        <div className='overlay'>
          <div className='container'>
            <div className='row'>
              <div
                className='col-md-8 col-md-offset-2 intro-text'
                data-aos='fade-up'
                data-aos-delay='300'
              >
                <h2 style={{color:"white"}} >Unity ERP Solutions</h2>
                <div>
                  <h4 style={{ color: 'white' }}>Streamline Your Operations Across Sectors
</h4>
                  {/* <p>RedRuby Technologies is proud to offer customized Odoo Unity ERP solutions tailored to the specific needs of government and private sector organizations. Odoo Unity ERP is a comprehensive, open-source platform designed to centralize and optimize your business processes.
</p> */}
                </div>
              
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
